export default __webpack_public_path__ + "static/media/certificates-download.721e84c5.png";